module.exports = __webpack_public_path__ + "img/chr_ts_6_penlight.7e0f6435.png";